// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"mV-z","inlineTitle":"nV-z","sponsoredAdsWrapper":"oV-z","marketplaceRecosWrapper":"pV-z"};